import { render, staticRenderFns } from "./CElementCover.vue?vue&type=template&id=7f06ebee"
import script from "./CElementCover.vue?vue&type=script&lang=js"
export * from "./CElementCover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports